import { Animation, createAnimation  } from '@ionic/angular';
import {modalEnterAnimation} from "./animation.enter";

export const modalLeaveAnimation = (
    baseEl: HTMLElement,
    duration = 500
): Animation => {
    return modalEnterAnimation(baseEl).direction('reverse');
};
